<template>
  <v-card>
    <v-card-title class="primary accent--text">
      Basket
    </v-card-title>
    <v-card-text>
      <v-row
        v-if="isLoading"
        align="center"
        justify="center"
      >
        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
          >
            <v-progress-circular
              :size="100"
              :width="5"
              color="primary"
              indeterminate
            />
          </v-row>
        </v-col>

        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
          >
            <span>Loading {{ invoice.lines.total_count }} items</span>
          </v-row>
        </v-col>

      </v-row>
      <v-simple-table v-if="!isLoading">
        <table>
          <thead>
            <tr>
              <th width="40%">
                Description
              </th>
              <th>Qty</th>
              <th class="text-right">
                Unit price
              </th>
              <th>Tax</th>
              <th>Amount</th>
              <th/>
            </tr>
          </thead>
          <tbody>
            <template v-for="(ii, index) in getBasket">
              <tr :key="`basket_item_${index}`">
                <td>
                  <v-text-field
                    hide-details
                    outlined
                    dense
                    :value="basketMap[ii.id].description"
                    :disabled="isDescriptionDisabled(ii)"
                    @change="doUpdateInvoiceItem(ii.id, 'description', $event)"
                  />
                </td>
                <td>
                  <v-text-field
                    hide-details
                    outlined
                    dense
                    :value="basketMap[ii.id].quantity"
                    :disabled="isQuantityDisabled(ii)"
                    @change="doUpdateInvoiceItem(ii.id, 'quantity', $event)"
                  />
                </td>
                <td>
                  <!--
                  Because we cannot add coupons yet to invoices, allow unit prices to be manually adjusted
                  -->
                  <amount-input
                    v-if="_isNumber(basketMap[ii.id].unit_amount)"
                    :disabled="isUnitPriceDisabled(ii)"
                    :init-amount="basketMap[ii.id].unit_amount"
                    :hide-details="true"
                    :label="''"
                    @change="doUpdateInvoiceItem(ii.id, 'unit_amount', $event)"
                  />
                </td>
                <td>
                  {{ getTaxRateTotals(ii.tax_rates) }}
                </td>
                <td class="text-right" v-money="{
                  amount: getAmount(ii.id),
                  currency: invoice.currency,
                  hideCurrency: true
                }"/>
                <td>
                  <v-progress-circular
                    v-if="isItemLoadingMap[ii.id] === true"
                    :size="20"
                    :width="2"
                    color="primary"
                    indeterminate
                  />
                  <v-menu
                    v-if="isItemLoadingMap[ii.id] !== true"
                    left
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        v-on="on"
                      >
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item disabled>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-icon
                              left
                              small
                              disabled
                            >
                              gavel
                            </v-icon>
                            Set item tax
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="!isRecurringProduct(ii)"
                        @click="doDeleteInvoiceItem(ii.id)"
                      >
                        <v-list-item-content>
                          <v-list-item-title class="error--text">
                            <v-icon
                              left
                              small
                              color="error"
                            >
                              delete
                            </v-icon>
                            Delete
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </v-simple-table>
      <v-simple-table v-if="!isLoading">
        <tbody>
          <tr>
            <td style="vertical-align: top" class="py-3">
              <v-btn
                :disabled="isCreatingLineItems"
                :loading="isCreatingLineItems"
                small
                rounded
                outlined
                color="primary"
                @click="createBlankLineItem"
              >
                <v-icon left small>
                  add
                </v-icon>

                Line Item
              </v-btn>

              <span class="mx-3 grey--text">or</span>

              <product-select-dialog
                @action="addVariantsToInvoice"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    :disabled="isCreatingLineItems"
                    :loading="isCreatingLineItems"
                    small
                    rounded
                    outlined
                    color="primary"
                    v-on="on"
                  >
                    <v-icon left small>add</v-icon>

                    Product
                  </v-btn>
                </template>
              </product-select-dialog>
            </td>
            <td class="pa-0">
              <v-simple-table>
                <table>
                  <tbody>
                    <!-- SubTotal Row -->
                    <tr>
                      <td/>
                      <td/>
                      <td/>
                      <td>Subtotal:</td>
                      <td class="text-right" v-money="{
                amount: subtotal,
                currency: invoice.currency,
                hideCurrency: true
              }"/>
                      <td/>
                    </tr>

                    <!-- Customer Balance Row -->

                    <tr
                      v-if="hasCustomerBalance()"
                    >
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>
                        <span class="caption grey--text">Customer Balance</span>
                      </td>
                      <td
                        class="text-right"
                        v-money="{
                amount:invoice.starting_balance,
                currency: invoice.currency,
                hideCurrency: true
              }">
                      </td>
                      <td></td>
                    </tr>

                    <!-- Inclusive Taxes -->
                    <template v-for="(tax, taxIncIndex) in inclusiveTaxes">
                      <tr :key="`inc_${taxIncIndex}`">
                        <td>asdf</td>
                        <td/>
                        <td/>
                        <td class="grey--text caption">
                          {{ tax.tax_rate.display_name }} - {{ tax.tax_rate.jurisdiction }} {{
                          tax.tax_rate.percentage }}%
                          <span>incl.</span>
                        </td>
                        <td
                          class="text-right"
                          v-money="{
                  amount: tax.amount,
                  currency: invoice.currency,
                  hideCurrency: true
                }"/>
                        <td/>
                      </tr>
                    </template>

                    <!-- Coupon Row -->
                    <tr v-if="hasCoupon">
                      <td/>
                      <td/>
                      <td/>
                      <td>
                <span
                  v-if="hasCoupon"
                >
                  <span>Discount: <span class="grey--text">{{ _get(invoice, 'discount.coupon.name', '') }}</span></span><br>
                  <span class="caption grey--text">{{ couponTerms() }}</span>
                </span>

                        <!-- Currently not available in Stripe API -->
                        <!--                <coupon-select-dialog-->
                        <!--                  v-if="!hasCoupon"-->
                        <!--                  @action="onSelectCoupon"-->
                        <!--                >-->
                        <!--                  <template v-slot:activator="{ on }">-->
                        <!--                    <v-btn-->
                        <!--                      small-->
                        <!--                      text-->
                        <!--                      rounded-->
                        <!--                      outlined-->
                        <!--                      color="primary"-->
                        <!--                      v-on="on"-->
                        <!--                    >-->
                        <!--                      add coupon-->
                        <!--                    </v-btn>-->
                        <!--                  </template>-->
                        <!--                </coupon-select-dialog>-->
                      </td>
                      <td class="text-right">
                        {{ getDiscountTotal() }}
                      </td>
                      <td>
                        <!--                <v-menu-->
                        <!--                  v-if="hasCoupon && false"-->
                        <!--                  left-->
                        <!--                >-->
                        <!--                  <template v-slot:activator="{ on }">-->
                        <!--                    <v-btn-->
                        <!--                      icon-->
                        <!--                      small-->
                        <!--                      v-on="on"-->
                        <!--                    >-->
                        <!--                      <v-icon>more_vert</v-icon>-->
                        <!--                    </v-btn>-->
                        <!--                  </template>-->

                        <!--                  <v-list dense>-->
                        <!--                    <v-list-item @click="removeCoupon()">-->
                        <!--                      <v-list-item-title class="red&#45;&#45;text">-->
                        <!--                        <v-icon-->
                        <!--                          color="red"-->
                        <!--                          left-->
                        <!--                          small-->
                        <!--                        >-->
                        <!--                          close-->
                        <!--                        </v-icon>-->

                        <!--                        Remove Coupon-->
                        <!--                      </v-list-item-title>-->
                        <!--                    </v-list-item>-->
                        <!--                  </v-list>-->
                        <!--                </v-menu>-->
                      </td>
                    </tr>

                    <!-- Exclusive Taxes -->
                    <template v-for="(tax, taxId) in exclusiveTaxes">
                      <tr :key="`excl_tax_${taxId}`">
                        <td/>
                        <td/>
                        <td/>
                        <td class="grey--text caption">
                          {{ tax.tax_rate.display_name }} - {{ tax.tax_rate.jurisdiction }} {{
                          tax.tax_rate.percentage }}%
                        </td>
                        <td
                          class="text-right"
                          v-money="{
                            amount: tax.amount,
                            currency: invoice.currency,
                            hideCurrency: true
                          }"/>
                        <td/>
                      </tr>
                    </template>

                    <!-- Taxes Row -->
                    <tr>
                      <td/>
                      <td/>
                      <td/>
                      <td>
                        <tax-rate-select-dialog
                          :init-selected="defaultTaxRates"
                          @action="onSelectTaxRates"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              text
                              rounded
                              outlined
                              color="primary"
                              v-on="on"
                            >
                              {{ defaultTaxRates.length > 0 ? 'update' : 'add' }} taxes
                            </v-btn>
                          </template>
                        </tax-rate-select-dialog>
                      </td>
                      <td/>
                      <td/>
                    </tr>

                    <!-- Total Row -->
                    <tr>
                      <td/>
                      <td/>
                      <td/>
                      <td>
                        Total ({{ invoice.currency ? invoice.currency.toUpperCase() : ''
                        }}):
                      </td>
                      <td
                        class="text-right"
                        v-money="{
                amount: total,
                currency: invoice.currency,
                hideCurrency: true
              }"/>
                      <td/>
                    </tr>
                  </tbody>
                </table>
              </v-simple-table>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { get, isEmpty, isNumber, isObject } from 'lodash'
import ProductSelectDialog from "../Product/ProductSelectDialog"
import TaxRateSelectDialog from "../TaxRate/TaxRateSelectDialog"
import CouponSelectDialog from "../Coupon/CouponSelectDialog"
import AmountInput from "../Common/AmountInput"
import { readableCouponTerms } from "../../services/stripe.service"
import { discountTotal } from "../../services/util.service"

export default {
  components: {
    AmountInput,
    CouponSelectDialog,
    TaxRateSelectDialog,
    ProductSelectDialog
  },
  props: {
    initInvoice: {
      required: true,
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isLoading: false,
      invoice: {},
      basketMap: {},
      coupon: null,
      defaultTaxRates: [],
      isCreatingLineItems: false,
      isItemLoadingMap: {}
    }
  },
  computed: {
    ...mapGetters([
      'getProductOptionLabel'
    ]),
    getBasket() {
      return Object.values(this.basketMap)
    },
    subtotal() {
      return this.invoice.subtotal
    },
    subtotalMinusDiscount() {
      return this.subtotal - this.discountTotal
    },
    inclusiveTaxes() {
      return get(this.invoice, 'total_tax_amounts', []).filter(t => t.inclusive)
    },
    // The total of the sub
    inclusiveTaxTotal() {
      const taxesSum = this.inclusiveTaxesPercentageSum
      return (this.subtotalMinusDiscount) - (this.subtotalMinusDiscount / (1 + (taxesSum / 100)))
    },
    inclusiveTaxesPercentageSum() {
      return this.inclusiveTaxes.reduce((prev, curr) => prev + curr.percentage, 0)
    },
    exclusiveTaxes() {
      return get(this.invoice, 'total_tax_amounts', []).filter(t => !t.inclusive)
    },
    total() {
      return this.invoice.total + parseInt(this.invoice.starting_balance, 10)
      // const sum = this.exclusiveTaxes.reduce((prev, tax) => {
      //   return prev + this.calculateExclusiveBasketTax(tax)
      // }, this.subtotal)
      //
      // return sum - this.discountTotal
    },
    hasCoupon() {
      return !isEmpty(get(this.invoice, 'discount.coupon'))
    },
    isItemLoading() {
      return function (id) {
        return this.isItemLoading[ id ] === true
      }
    }
  },
  watch: {
    initInvoice() {
      // don't think we want to replace all fields here, so cherry-pick as needed
      // The UI will update lines or other things we dont want to touch while the user is making
      // multiple changes
      const { total_tax_amounts, total, starting_balance } = this.initInvoice

      this.invoice = {
        ...this.invoice,
        total_tax_amounts,
        total,
        starting_balance
      }
    }
  },
  mounted() {
    this.invoice = { ...this.initInvoice }

    // Recursively load all the line items
    let lineItems = []

    const loadLineItems = (startingAfter) => {
      const listItemsPayload = {
        query: {
          limit: 100,
          invoice: this.invoice.id
        }
      }

      if (startingAfter) {
        listItemsPayload.query.starting_after = startingAfter
      }

      this.listInvoiceItems(listItemsPayload)
        .then(res => {
          const { data, has_more } = res

          lineItems = [ ...lineItems, ...data ]

          if (has_more) {
            const lastId = get(data, `[${data.length - 1}].id`)
            loadLineItems(lastId)
          } else {
            this.setBasketMapFromLineItems(lineItems)
            this.isLoading = false
          }
        })
    }

    if (get(this.invoice, 'lines.total_count', 0) > 0) {
      this.isLoading = true
      loadLineItems()
    }

    const defaultTaxRates = get(this.initInvoice, 'default_tax_rates', [])
    if (!isEmpty(defaultTaxRates)) {
      this.defaultTaxRates = [ ...defaultTaxRates ]
    }

    const coupon = get(this.initInvoice, 'discount.coupon', {})
    if (!isEmpty(coupon)) {
      this.coupon = coupon
    }

  },
  methods: {
    ...mapActions([ 'deleteInvoiceItem', 'updateInvoiceItem', 'createInvoiceItem', 'listInvoiceItems', 'getInvoice' ]),
    _get: (val, path, def) => get(val, path, def),
    isDescriptionDisabled(ii) {
      return this.isInvoiceItemProduct(ii) || this.isRecurringProduct(ii)
    },
    isQuantityDisabled(ii) {
      return this.isRecurringProduct(ii)
        || !isEmpty(get(ii, 'metadata.booking_product'))
    },
    isUnitPriceDisabled(ii) {
      return this.isRecurringProduct(ii)
    },
    getDiscountTotal() {
      const payload = {
        subtotal: this.subtotal,
        currency: this.invoice.currency,
        coupon: get(this.invoice, 'discount.coupon', {})
      }

      return discountTotal(payload)
    },
    setBasketMapFromLineItems(lineItems) {
      const items = lineItems || []
      // Stripe API doesnt provide unit_amount in expanding invoice :/, map it for our own basket
      this.basketMap = items.reduce((prev, curr) => {
        if (!curr.unit_amount) {
          // dont divide by zero
          curr.unit_amount = curr.quantity === 0 ? 0 : curr.amount / curr.quantity
        }

        return {
          ...prev,
          [ curr.id ]: curr
        }
      }, {})
    },
    hasCustomerBalance() {
      // has balance that is not 0
      return isNumber(this.invoice.starting_balance)
        && (this.invoice.starting_balance > 0 || this.invoice.starting_balance < 0)
    },
    isABasketItemLoading() {
      // Used by parent
      return Object.values(this.isItemLoadingMap).includes(true)
    },
    isRecurringProduct(item) {
      return item.subscription || item.subscription_item
    },
    _isNumber: (val) => isNumber(val),
    getTaxRateTotals(taxRates) {
      let inclusiveTotal = 0
      let exclusiveTotal = 0

      taxRates.forEach(tr => {
        tr.inclusive
          ? inclusiveTotal += tr.percentage
          : exclusiveTotal += tr.percentage
      })

      if (inclusiveTotal > 0 && exclusiveTotal > 0) {
        return `${inclusiveTotal}% incl. + ${exclusiveTotal}%`
      }
      if (inclusiveTotal > 0 && exclusiveTotal === 0) {
        return `${inclusiveTotal}% incl.`
      }
      if (inclusiveTotal === 0 && exclusiveTotal > 0) {
        return `${exclusiveTotal}%`
      }
      return ''

    },
    setIsItemLoading(id, value) {
      if (id) {
        this.isItemLoadingMap = {
          ...this.isItemLoadingMap,
          [ id ]: !!value
        }
      }
    },
    async doUpdateInvoiceItem(id, field, value) {
      const basket = { ...this.basketMap }

      // Only update if there is a change
      if (basket[ id ][ field ] !== value) {
        const oldValue = value
        const payload = {
          id,
          [ field ]: value,
          expand: [ 'invoice.customer', 'invoice.total_tax_amounts.tax_rate' ]
        }

        basket[ id ][ field ] = value
        this.setIsItemLoading(id, true)
        await this.updateInvoiceItem(payload)
          .then((res) => {
            this.invoice = res.invoice // shouldn't overwrite params, but w/e
            this.basketMap = basket
          })
          .catch(() => {
            basket[ id ][ field ] = oldValue
          })
          .finally(() => {
            this.setIsItemLoading(id, false)
          })
      }

    },
    async doDeleteInvoiceItem(id) {
      const payload = { id }

      this.setIsItemLoading(id, true)
      await this.deleteInvoiceItem(payload)
        .then(() => {
          this.refetchInvoice()
          const basket = { ...this.basketMap }
          delete basket[ id ]
          this.basketMap = basket
        })
        .finally(() => {
          this.setIsItemLoading(id, false)
        })
    },
    getAmount(id) {
      return (get(this.basketMap, `[${id}].unit_amount`, 0) * get(this.basketMap, `[${id}].quantity`, 0))
        || get(this.basketMap, `[${id}].amount`, 0)
    },
    emitUpdate() {
      // Formatting local values for API. Only IDs are required for some
      const payload = {
        lines: Object.values(this.basketMap),
        coupon: this.coupon === null ? null : get(this.coupon, 'id'),
        default_tax_rates: this.defaultTaxRates.map(tr => tr.id)
      }
      this.$emit('update', payload)
    },
    removeCoupon() {
      this.coupon = null
    },
    couponTerms() {
      const coupon = get(this.invoice, 'discount.coupon')
      return coupon ? readableCouponTerms(coupon) : ''
    },
    onSelectCoupon(coupon) {
      this.coupon = coupon
    },
    isInvoiceItemProduct: (item) => {
      return !isEmpty(get(item, 'metadata.variant'))
      || !isEmpty(get(item, 'metadata.product'))
      || !isEmpty(get(item, 'metadata.booking_product'))
    },
    onSelectTaxRates(taxes) {
      this.defaultTaxRates = [ ...taxes ]
      this.emitUpdate()
    },
    optionsToText(productId, options) {
      const textOptions = []
      for (const [ key, option ] of Object.entries(options)) {
        textOptions.push(`${this.getProductOptionLabel(productId, key)}: ${option.value}`)
      }

      return textOptions.join(', ')
    },
    addVariantsToInvoice(variants) {

      const mapVariantToLineItem = (variant) => ({
        id: variant.id,
        description: `${variant.sku} | ${this.optionsToText(variant.productId, variant.options)}`,
        unit_amount: variant.amount,
        quantity: 1, // user can adjust to whatever they want. 1 for a simple base case. Better than 0.
        metadata: {
          variantId: variant.id
        }
      })

      const preparedItems = variants.map(v => mapVariantToLineItem(v))

      this.isCreatingLineItems = true
      const results = Promise.all(
        preparedItems.map(item => this.createLineItem(item))
      ).then(() => {
      })
        .finally(() => {
          this.isCreatingLineItems = false
        })
    },
    createBlankLineItem() {
      this.isCreatingLineItems = true
      this.createLineItem({})
        .finally(() => {
          this.isCreatingLineItems = false
        })
    },
    createLineItem(item) {
      const {
        id,
        description = '',
        quantity = 1,
        metadata = {},
        amount = 0,
        unit_amount = 0,
        tax_rates = []
      } = item

      const lineItem = {
        expand: [ 'invoice.customer', 'invoice', 'invoice.total_tax_amounts.tax_rate' ],
        id,
        invoice: this.$route.params.id,
        customer: this.invoice.customer.id,
        currency: this.invoice.currency,
        description,
        quantity,
        metadata,
        amount, // this is the total amount of the line item.
        unit_amount, // this value will be multiplied against the quantity
        tax_rates,
      }

      return this.createInvoiceItem(lineItem)
        .then((response) => {
          const invoice = response.invoice

          if (isObject(invoice)) {
            this.invoice = { ...invoice }
          }

          this.basketMap = {
            ...this.basketMap,
            [ response.id ]: response
          }
        })
    },
    refetchInvoice() {
      const payload = {
        _reload: true,
        id: this.invoice.id,
        expand: [ 'total_tax_amounts.tax_rate', 'customer' ]
      }

      this.getInvoice(payload)
        .then((res) => {
          this.invoice = res
        })
    }
  }
}
</script>
